import Router from 'vue-router';
// import Config from './config';
// import * as Rocket from '@superpitch/core-rocket-frontend';
// import * as BrowserUtils from '@/utils/browser';
// import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import Admin from '@/pages/admin/Admin.vue';
import Redirect from '@/pages/redirect/Redirect.vue';

/**
 * Route mapping
 */
export const MAPPING = {
    admin: '/a/admin',
    redirect: '/:id',
};

/**
 * Other routes
 */
export const ROUTES = [
    {
        component: Admin,
        path: MAPPING.admin,
        meta: { requiresAuth: false, access: '', single: true },
        name: 'admin',
    },
    {
        component: Redirect,
        path: MAPPING.redirect,
        meta: { requiresAuth: false, access: '', single: true },
        name: 'redirect',
    }
];

export const ADMIN_MENUS = [
    /*{
        component: AdminInsurers,
        path: MAPPING.adminInsurers,
        meta: { requiresAuth: true, access: 'frontAdminInsurers', single: true },
        name: 'adminInsurers',
        label: 'l_insurers',
    }*/
];

/**
 * The router with all the routes
 */
export const ROUTER = new Router({
    mode: 'history',
    routes: [...ROUTES, ...ADMIN_MENUS],
});

ROUTER.beforeEach((to: any, _: any, next: any) => {
    /*if (to.matched.some((record: any) => record.meta.requiresAuth)) {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const rocket = new Rocket.RocketFrontend(user.key || '', user.secret || '', Config.apiUrl);

        const req$ = rocket.request('faccess', 'action', null, {
            type: 'r',
            name: to.meta.access,
        });
        req$.subscribe((res: AjaxResponse) => {
            const { response = {} } = rocket.unpackResponse(res);
            if (response.ok) {
                next();
                return;
            }
            next({
                path: '/login',
            });
        }, (err: AjaxError) => {
            const { code } = rocket.unpackError(err);
            console.error('Error while trying to check frontend access', code);
            next({
                path: '/login',
            });
        });
    } else {
        next();
    }*/
    next();
});
